import styled from 'styled-components';

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;
